import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const incorporationDatesListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'fromYearStart',
    label: 'Number of years',
  },
  {
    name: 'riskScore',
    label: 'Score',
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
];

export const incorporationDatesListColumnsLabels = {
  fromYearStart: 'From Year',
};

export const incorporationDatesListDefaultSorter = {};

export const incorporationDatesListSchema = {
  fromYearStart: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const incorporationDatesListFiltersSchema = [
  {
    name: 'fromYearStart',
    type: FilterType.TEXT,
    placeholder: 'Enter year...',
  },
];
